import { useAtom, useAtomValue, useSetAtom } from "jotai";
import { useCallback, useEffect } from "react";
import type { MapLayerMouseEvent } from "react-map-gl";
import {
  activeSelectionAtom,
  clearSelectionAtom,
  interactiveLayerAtom,
  mapInstanceAtom,
} from "~/stores";

const layers = ["mapbox-gl-draw-hot", "mapbox-gl-draw-cold"];
export default function useClearActive() {
  const [active] = useAtom(activeSelectionAtom);
  const clearActive = useSetAtom(clearSelectionAtom);
  const map = useAtomValue(mapInstanceAtom);

  const resetActive = useCallback(
    (evt: MapLayerMouseEvent) => {
      if (!active.length) return;
      // mapbox-gl-draw-hot
      const clickDrawnFeature = evt.target
        .queryRenderedFeatures(evt.point)
        .filter((f) => layers.includes(f.source));

      const { metaKey, shiftKey } = evt.originalEvent;
      if (metaKey || shiftKey) return;
      if (
        (!evt.features || evt.features.length === 0) &&
        !clickDrawnFeature.length
      ) {
        // const { lngLat } = evt;
        clearActive();
        return;
      }
    },
    [active, clearActive]
  );

  useEffect(() => {
    if (!map) return;
    map.on("click", resetActive);

    return () => {
      map.off("click", resetActive);
    };
  }, [map, resetActive]);

  return resetActive;
}

export function useClearActiveEmbed() {
  const [active, setActive] = useAtom(activeSelectionAtom);
  const map = useAtomValue(mapInstanceAtom);
  const interactiveLayers = useAtomValue(interactiveLayerAtom);

  const resetActive = useCallback(
    (evt: MapLayerMouseEvent) => {
      if (!active.length) return;
      //mapbox-gl-draw-hot
      const clickDrawnFeature = evt.target
        .queryRenderedFeatures(evt.point)
        .filter((f) => interactiveLayers.includes(f.source));

      if (
        (!evt.features || evt.features.length === 0) &&
        !clickDrawnFeature.length
      ) {
        // const { lngLat } = evt;
        setActive([]);
        return;
      }
    },
    [active, setActive, interactiveLayers]
  );

  useEffect(() => {
    if (!map) return;
    map.on("click", resetActive);

    return () => {
      map.off("click", resetActive);
    };
  }, [map, resetActive]);

  return resetActive;
}
